// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"4796": "dc6e29ce","5545": "20927b2f","6259": "c7acad5b","7869": "22f405b2",}[chunkId] + ".css"
}